import React, { useState } from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import SvgIcon from "../../../../../parts/SvgIcon";
import { getDateToDisplay } from "../../../../../utils/nutrition-helpers";
import { calculateStartAndEndDateOfTheWeeks } from "../../../../../utils/date-helpers";

export const MealPlannerWeekSelector = ({ query, mealPlan }) => {
  const { week = 1 } = query;
  const { weeks: originalWeeks = [] } = mealPlan;
  const weeks = calculateStartAndEndDateOfTheWeeks(originalWeeks);
  /**
   * Function to select the week
   * @param {*} position
   */
  const handleWeekSelector = (position) => {
    // Ensure the week is within valid bounds
    if (position >= 1 && position <= weeks.length) {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          week: position,
        },
      });
    }
  };

  return (
    <div className="week-selector">
      <button
        className="arrow-button -mr-2"
        onClick={() => handleWeekSelector(week - 1)}
        disabled={week <= 1} // Disable the button if the week is already at the minimum
      >
        <SvgIcon src="/img/new-icons/arrow-left.svg" alt="left" />
      </button>
      {weeks.map(({ startDate, endDate, isCompleted }, index) => {
        let buttonText;

        if (startDate && endDate) {
          if (startDate === endDate) {
            buttonText = getDateToDisplay(startDate);
          } else {
            buttonText = `${getDateToDisplay(startDate)} - ${getDateToDisplay(
              endDate
            )}`;
          }
        } else {
          buttonText = `Week ${index + 1}`;
        }

        return (
          <button
            key={`${startDate}-${endDate}-${index}`}
            className="week-button"
            data-button-type={week === index + 1 ? "outline" : "secondary"}
            onClick={() => handleWeekSelector(index + 1)}
          >
            <SvgIcon
              src={
                isCompleted
                  ? "/img/new-icons/checked-circle.svg"
                  : "/img/new-icons/info-circle.svg"
              }
              alt="info"
              noFilterOnLight={true}
            />
            <span
              className={
                week === index + 1 ? "ml-1  opacity-100" : "ml-1 opacity-70"
              }
            >
              {buttonText}
            </span>
          </button>
        );
      })}
      <button
        className="arrow-button -ml-2"
        disabled={week >= weeks.length} // Disable the button if the week is already at the maximum
        onClick={() => handleWeekSelector(week + 1)}
      >
        <SvgIcon src="/img/new-icons/arrow-right.svg" alt="right" />
      </button>
    </div>
  );
};

MealPlannerWeekSelector.propTypes = {
  mealPlan: PropTypes.object,
  query: PropTypes.object,
};
